import { Component } from '@angular/core';
import { ViewCompanyDetails } from '../../../../components/admin-dashboard-component/admin-companies-component/view-company-details/view-company-details';

@Component({
  selector: 'app-view-company',
  imports: [ViewCompanyDetails],
  templateUrl: './view-company.html',
  styleUrl: './view-company.scss',
})
export class ViewCompany {}
